// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3RMH3","footer":"styles_footer__cFxgs"};